export default __webpack_public_path__ + "static/media/bank_bni.a524a109.svg";